{
  "nav": {
    "login": "Sign in"
  },
  "hero": {
    "badge": "Face & fingerprint attendance",
    "title": "Employee attendance and payroll — on autopilot",
    "subtitle": "A face- and fingerprint-recognition terminal at the entrance, live check-ins and check-outs, timesheets, vacations and payroll reports — all in one platform.",
    "cta": "Book a demo",
    "ctaSecondary": "Sign in",
    "mock": {
      "title": "Today",
      "checkedIn": "Checked in",
      "late": "Late",
      "onVacation": "Vacation"
    }
  },
  "features": {
    "title": "Everything you need to manage your team",
    "subtitle": "From the first glance at the terminal to the final payroll figure — without spreadsheets and manual counting.",
    "items": {
      "terminal": {
        "title": "Face/fingerprint recognition",
        "text": "Employees check in with a glance or a fingerprint — no cards, no queues."
      },
      "live": {
        "title": "Entries & exits live",
        "text": "Every check-in and check-out appears in the platform instantly. Late arrivals are visible right away."
      },
      "reports": {
        "title": "Timesheets & payroll",
        "text": "Attendance grid, lateness deductions, overtime, advances and the final pay — calculated automatically."
      },
      "timeoff": {
        "title": "Vacations & time off",
        "text": "Vacations, sick leave and business trips are planned in advance and included in every calculation."
      },
      "notifications": {
        "title": "Telegram notifications",
        "text": "Check-in and lateness alerts delivered straight to your Telegram group."
      },
      "languages": {
        "title": "Three languages",
        "text": "The whole interface is available in Armenian, Russian and English."
      }
    }
  },
  "how": {
    "title": "How it works",
    "steps": {
      "one": {
        "title": "We install the terminal",
        "text": "A face- and fingerprint-recognition terminal is mounted at your entrance and connected to the platform in minutes."
      },
      "two": {
        "title": "Employees check in with a glance or a fingerprint",
        "text": "Every entry and exit is recognized and recorded automatically — no cards or paper logs."
      },
      "three": {
        "title": "You get the numbers",
        "text": "Dashboards, timesheets and payroll reports are always up to date and ready to export."
      }
    }
  },
  "book": {
    "title": "Book a demo",
    "subtitle": "Leave your contact details — we will get in touch and show the platform in action.",
    "form": {
      "name": "Your name",
      "namePlaceholder": "Name Surname",
      "phone": "Phone",
      "phonePlaceholder": "+374 ...",
      "submit": "Send request",
      "sending": "Sending…",
      "required": "Please fill in your name and phone number.",
      "success": "Thank you! Your request has been received — we will contact you soon.",
      "successAnother": "Send another request",
      "error": "Failed to send the request. Please try again or contact us directly."
    },
    "contactTitle": "Or contact us directly",
    "emailLabel": "Email",
    "phoneLabel": "Phone"
  },
  "footer": {
    "rights": "All rights reserved."
  },
  "seo": {
    "title": "Employee Management Platform — attendance, timesheets, payroll",
    "description": "Face/fingerprint terminal at the entrance, live check-ins and check-outs, timesheets, vacations, payroll and Telegram notifications — all in one platform. Book a demo."
  }
}
